import { useState, useEffect } from 'react';

const AUTH_URL = 'https://backcvbgtmdesa.azurewebsites.net/api/login/authenticate';
const USUARIOS_URL = 'https://backcvbgtmdesa.azurewebsites.net/api/Usuarios';
const IMG_BASE = 'https://backcvbgtmdesa.azurewebsites.net/';

const initials = (u) =>
  `${u.Nombre?.[0] ?? ''}${u.Apellido?.[0] ?? ''}`.toUpperCase();

const AVATAR_COLORS = ['#C0392B','#1a5276','#1a7a3c','#7d6608','#9b59b6','#2e86c1'];
const avatarColor = (login) => AVATAR_COLORS[(login?.charCodeAt(0) ?? 0) % AVATAR_COLORS.length];

async function getToken() {
  const stored = localStorage.getItem('token');
  if (stored) return stored;
  const res = await fetch(AUTH_URL, {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify({ username: 'adminGuastatoya', password: '123456a' }),
  });
  const data = await res.json();
  if (data.token) localStorage.setItem('token', data.token);
  return data.token;
}

export default function AdminUsuarios() {
  const [usuarios, setUsuarios]       = useState([]);
  const [loading, setLoading]         = useState(true);
  const [error, setError]             = useState(null);
  const [busqueda, setBusqueda]       = useState('');
  const [filtroRol, setFiltroRol]     = useState('');
  const [filtroCompania, setFiltroCompania] = useState('');
  const [companias, setCompanias]     = useState([]);
  const [pagina, setPagina]           = useState(1);
  const POR_PAGINA = 15;

  useEffect(() => {
    const cargar = async () => {
      try {
        const token = await getToken();
        const res = await fetch(USUARIOS_URL, {
          headers: { Authorization: `Bearer ${token}` },
        });
        if (!res.ok) throw new Error('Error al obtener usuarios');
        const data = await res.json();
        setUsuarios(data);
        const comps = [...new Map(
          data.flatMap(u => u.Companias).map(c => [c.Cod_Compania, c])
        ).values()];
        setCompanias(comps);
      } catch (e) {
        setError('No se pudo cargar la lista de usuarios.');
      } finally {
        setLoading(false);
      }
    };
    cargar();
  }, []);

  const filtrados = usuarios.filter(u => {
    const texto = `${u.Nombre} ${u.Apellido} ${u.Login} ${u.Correo}`.toLowerCase();
    const matchBusqueda  = texto.includes(busqueda.toLowerCase());
    const matchRol       = filtroRol
      ? u.Roles.some(r => r.Descripcion_Corta === filtroRol)
      : true;
    const matchCompania  = filtroCompania
      ? u.Companias.some(c => String(c.Cod_Compania) === filtroCompania)
      : true;
    return matchBusqueda && matchRol && matchCompania;
  });

  const totalPaginas = Math.ceil(filtrados.length / POR_PAGINA);
  const paginados = filtrados.slice((pagina - 1) * POR_PAGINA, pagina * POR_PAGINA);

  const roles = [...new Set(usuarios.flatMap(u => u.Roles.map(r => r.Descripcion_Corta)))];

  const stats = {
    total:     usuarios.length,
    conRol:    usuarios.filter(u => u.Roles.length > 0).length,
    sinRol:    usuarios.filter(u => u.Roles.length === 0).length,
    conCompania: usuarios.filter(u => u.Companias.length > 0).length,
  };

  return (
    <div style={{ minHeight: '100vh', background: '#f0f4f8', fontFamily: "'Inter','Segoe UI',sans-serif" }}>
      <style>{`
        @import url('https://fonts.googleapis.com/css2?family=Inter:wght@400;500;600;700;800&display=swap');
        
        .au-header { background: linear-gradient(135deg, #0f172a 0%, #1e293b 100%); color: #fff; padding: 20px 24px; }
        .au-header h1 { margin: 0; font-size: 1.8rem; font-weight: 800; }
        .au-header p { margin: 4px 0 0; font-size: .9rem; opacity: 0.8; }

        .au-container { max-width: 1400px; margin: 0 auto; padding: 24px; }
        
        .au-stats { display: grid; grid-template-columns: repeat(4, 1fr); gap: 16px; margin-bottom: 24px; }
        .au-stat { background: #fff; padding: 20px; border-radius: 12px; box-shadow: 0 1px 3px rgba(0,0,0,0.05); }
        .au-stat-val { font-size: 2rem; font-weight: 800; color: #1f2937; }
        .au-stat-lbl { font-size: .8rem; color: #6b7280; margin-top: 8px; font-weight: 600; text-transform: uppercase; }

        .au-filters { background: #fff; padding: 16px; border-radius: 12px; box-shadow: 0 1px 3px rgba(0,0,0,0.05); margin-bottom: 24px; }
        .au-filters-row { display: flex; gap: 12px; flex-wrap: wrap; }
        .au-filter-item { flex: 1; min-width: 180px; }
        .au-filter-item input, .au-filter-item select { width: 100%; padding: 10px 12px; border: 1px solid #d1d5db; border-radius: 8px; font-size: .9rem; font-family: 'Inter',sans-serif; outline: none; transition: all .2s; }
        .au-filter-item input:focus, .au-filter-item select:focus { border-color: #dc2626; box-shadow: 0 0 0 3px rgba(220,38,38,0.1); }

        .au-table-card { background: #fff; border-radius: 12px; box-shadow: 0 1px 3px rgba(0,0,0,0.05); overflow: hidden; }
        .au-table-header { padding: 16px; border-bottom: 1px solid #f3f4f6; display: flex; justify-content: space-between; align-items: center; }
        .au-table-header h2 { margin: 0; font-size: 1rem; font-weight: 700; color: #1f2937; }
        .au-table-header span { font-size: .85rem; color: #9ca3af; }

        .au-users-grid { display: grid; grid-template-columns: repeat(auto-fill, minmax(320px, 1fr)); gap: 16px; padding: 16px; }
        .au-user-card { background: #fff; border: 1px solid #f3f4f6; border-radius: 10px; padding: 16px; transition: all .2s; }
        .au-user-card:hover { box-shadow: 0 4px 12px rgba(0,0,0,0.08); transform: translateY(-1px); }
        
        .au-user-header { display: flex; align-items: center; gap: 12px; margin-bottom: 12px; }
        .au-avatar { width: 40px; height: 40px; border-radius: 50%; display: flex; align-items: center; justify-content: center; color: #fff; font-weight: 700; font-size: .85rem; }
        .au-user-name { font-weight: 700; color: #1f2937; font-size: .95rem; }
        .au-user-login { font-size: .8rem; color: #6b7280; }

        .au-user-info { margin: 12px 0; }
        .au-user-row { display: flex; justify-content: space-between; align-items: center; margin-bottom: 6px; font-size: .85rem; }
        .au-user-row-label { color: #6b7280; }
        .au-user-row-value { color: #1f2937; font-weight: 600; }

        .au-badge { display: inline-block; padding: 4px 10px; border-radius: 99px; font-size: .7rem; font-weight: 700; margin-right: 4px; margin-bottom: 4px; }
        .au-badge-admin { background: #fef3c7; color: #92400e; }
        .au-badge-oper { background: #dbeafe; color: #1e40af; }
        .au-badge-cmd { background: #fee2e2; color: #991b1b; }
        .au-badge-bomb { background: #dcfce7; color: #166534; }
        .au-badge-gray { background: #f3f4f6; color: #4b5563; }

        .au-pagination { padding: 16px; border-top: 1px solid #f3f4f6; display: flex; justify-content: center; gap: 6px; }
        .au-pagbtn { padding: 6px 10px; border: 1px solid #d1d5db; background: #fff; border-radius: 6px; font-size: .85rem; cursor: pointer; transition: all .2s; }
        .au-pagbtn:hover:not(:disabled) { background: #f3f4f6; border-color: #9ca3af; }
        .au-pagbtn:disabled { opacity: 0.4; cursor: not-allowed; }
        .au-pagbtn.active { background: #dc2626; color: #fff; border-color: #dc2626; }

        @media (max-width: 1200px) {
          .au-header { padding: 16px 20px; }
          .au-header h1 { font-size: 1.5rem; }
          .au-container { padding: 16px; }
          .au-stats { gap: 12px; }
          .au-stat { padding: 16px; }
          .au-stat-val { font-size: 1.5rem; }
        }

        @media (max-width: 1024px) {
          .au-stats { grid-template-columns: repeat(2, 1fr); }
          .au-users-grid { grid-template-columns: repeat(auto-fill, minmax(280px, 1fr)); gap: 12px; padding: 12px; }
        }

        @media (max-width: 768px) {
          .au-header { padding: 14px 16px; }
          .au-header h1 { font-size: 1.3rem; }
          .au-header p { font-size: .8rem; }
          .au-container { padding: 12px; }
          .au-stats { grid-template-columns: repeat(2, 1fr); gap: 10px; margin-bottom: 16px; }
          .au-stat { padding: 12px; }
          .au-stat-val { font-size: 1.3rem; }
          .au-stat-lbl { font-size: .7rem; }
          .au-filters { padding: 12px; margin-bottom: 16px; }
          .au-filters-row { gap: 8px; }
          .au-filter-item { min-width: 120px; }
          .au-filter-item input, .au-filter-item select { padding: 8px 10px; font-size: .85rem; }
          .au-users-grid { grid-template-columns: 1fr; gap: 10px; padding: 12px; }
          .au-user-card { padding: 12px; }
          .au-user-name { font-size: .9rem; }
          .au-table-header { padding: 12px; }
          .au-pagination { padding: 12px; gap: 4px; }
          .au-pagbtn { padding: 4px 8px; font-size: .75rem; }
        }

        @media (max-width: 480px) {
          .au-header { padding: 12px 14px; }
          .au-header h1 { font-size: 1.15rem; }
          .au-header p { font-size: .75rem; }
          .au-container { padding: 8px; }
          .au-stats { grid-template-columns: 1fr; gap: 8px; margin-bottom: 12px; }
          .au-stat { padding: 10px; }
          .au-stat-val { font-size: 1.1rem; }
          .au-stat-lbl { font-size: .65rem; margin-top: 4px; }
          .au-filters { padding: 10px; margin-bottom: 12px; }
          .au-filters-row { gap: 6px; flex-direction: column; }
          .au-filter-item { min-width: unset; }
          .au-filter-item input, .au-filter-item select { padding: 6px 8px; font-size: .8rem; }
          .au-users-grid { grid-template-columns: 1fr; gap: 8px; padding: 8px; }
          .au-user-card { padding: 10px; }
          .au-user-header { gap: 10px; margin-bottom: 10px; }
          .au-avatar { width: 36px; height: 36px; font-size: .75rem; }
          .au-user-name { font-size: .85rem; }
          .au-user-login { font-size: .75rem; }
          .au-user-info { margin: 8px 0; }
          .au-user-row { font-size: .8rem; margin-bottom: 4px; }
          .au-badge { padding: 2px 6px; font-size: .65rem; margin-right: 2px; margin-bottom: 2px; }
          .au-table-header { padding: 10px; font-size: .85rem; }
          .au-table-header h2 { font-size: .9rem; }
          .au-table-header span { font-size: .75rem; }
          .au-pagination { padding: 10px; gap: 2px; flex-wrap: wrap; }
          .au-pagbtn { padding: 3px 6px; font-size: .7rem; }
        }
      `}</style>

      {/* HEADER */}
      <div className="au-header">
        <h1>👥 Gestión de Usuarios</h1>
        <p>Administra los usuarios del sistema Cuerpo Voluntario de Bomberos - Jalapa</p>
      </div>

      <div className="au-container">
        {/* STATS */}
        <div className="au-stats">
          {[
            { val: stats.total, lbl: 'Total Usuarios' },
            { val: stats.conRol, lbl: 'Con Rol' },
            { val: stats.sinRol, lbl: 'Sin Rol' },
            { val: stats.conCompania, lbl: 'Con Compañía' },
          ].map((s, i) => (
            <div key={i} className="au-stat">
              <div className="au-stat-val">{s.val}</div>
              <div className="au-stat-lbl">{s.lbl}</div>
            </div>
          ))}
        </div>

        {/* FILTROS */}
        <div className="au-filters">
          <div className="au-filters-row">
            <div className="au-filter-item">
              <input
                type="text"
                placeholder="Buscar nombre, login, correo..."
                value={busqueda}
                onChange={e => { setBusqueda(e.target.value); setPagina(1); }}
              />
            </div>
            <div className="au-filter-item">
              <select
                value={filtroRol}
                onChange={e => { setFiltroRol(e.target.value); setPagina(1); }}
              >
                <option value="">Todos los roles</option>
                {roles.map(r => <option key={r} value={r}>{r}</option>)}
              </select>
            </div>
            <div className="au-filter-item">
              <select
                value={filtroCompania}
                onChange={e => { setFiltroCompania(e.target.value); setPagina(1); }}
              >
                <option value="">Todas las compañías</option>
                {companias.map(c => (
                  <option key={c.Cod_Compania} value={String(c.Cod_Compania)}>{c.Nombre}</option>
                ))}
              </select>
            </div>
          </div>
        </div>

        {/* CONTENIDO */}
        {loading ? (
          <div style={{ padding: '60px 20px', textAlign: 'center', color: '#9ca3af' }}>
            <div style={{ fontSize: '3rem', marginBottom: '16px' }}>⏳</div>
            <p>Cargando usuarios...</p>
          </div>
        ) : error ? (
          <div style={{ padding: '20px', background: '#fee2e2', border: '1px solid #fecaca', borderRadius: '8px', color: '#991b1b', fontSize: '.9rem' }}>
            ⚠️ {error}
          </div>
        ) : filtrados.length === 0 ? (
          <div style={{ padding: '60px 20px', textAlign: 'center', color: '#9ca3af' }}>
            <div style={{ fontSize: '3rem', marginBottom: '16px', opacity: 0.3 }}>👤</div>
            <p>No se encontraron usuarios con los filtros aplicados</p>
          </div>
        ) : (
          <>
            {/* GRID DE USUARIOS (TARJETAS) */}
            <div style={{ marginBottom: '24px' }}>
              <div className="au-table-header">
                <h2>Usuarios</h2>
                <span>{filtrados.length} usuarios</span>
              </div>
              <div className="au-users-grid">
                {paginados.map(u => {
                  const tipoRol = u.Roles.length > 0 ? u.Roles[0].Descripcion_Corta : null;
                  const badgeClass = tipoRol === 'Administrador' ? 'au-badge-admin' : 
                                    tipoRol === 'Operador' ? 'au-badge-oper' :
                                    tipoRol === 'Comandante' ? 'au-badge-cmd' :
                                    tipoRol === 'Bombero' ? 'au-badge-bomb' : 'au-badge-gray';
                  return (
                    <div key={u.Login} className="au-user-card">
                      <div className="au-user-header">
                        {u.url_Imagen && !u.url_Imagen.includes('user.png') ? (
                          <img
                            src={`${IMG_BASE}${u.url_Imagen}`}
                            alt=""
                            className="au-avatar"
                            style={{ width: '40px', height: '40px', borderRadius: '50%', objectFit: 'cover' }}
                          />
                        ) : (
                          <div
                            className="au-avatar"
                            style={{ background: avatarColor(u.Login) }}
                          >
                            {initials(u)}
                          </div>
                        )}
                        <div>
                          <div className="au-user-name">{u.Nombre} {u.Apellido}</div>
                          <div className="au-user-login">@{u.Login}</div>
                        </div>
                      </div>

                      <div className="au-user-info">
                        <div className="au-user-row">
                          <span className="au-user-row-label">📧 Email:</span>
                          <span className="au-user-row-value" style={{ fontSize: '.75rem' }}>{u.Correo}</span>
                        </div>
                        <div className="au-user-row">
                          <span className="au-user-row-label">📱 Teléfono:</span>
                          <span className="au-user-row-value">{u.Telefono || '—'}</span>
                        </div>
                      </div>

                      {u.Roles.length > 0 && (
                        <div style={{ marginBottom: '8px' }}>
                          <div style={{ fontSize: '.75rem', color: '#6b7280', marginBottom: '4px', fontWeight: 600 }}>ROLES</div>
                          {u.Roles.map(r => (
                            <span key={r.Cod_Rol} className={`au-badge ${badgeClass}`}>
                              {r.Descripcion_Corta}
                            </span>
                          ))}
                        </div>
                      )}

                      {u.Companias.length > 0 && (
                        <div>
                          <div style={{ fontSize: '.75rem', color: '#6b7280', marginBottom: '4px', fontWeight: 600 }}>COMPAÑÍA</div>
                          <div style={{ fontSize: '.85rem', color: '#1f2937', fontWeight: 600 }}>
                            {u.Companias.map(c => c.Nombre).join(', ')}
                          </div>
                        </div>
                      )}
                    </div>
                  );
                })}
              </div>
            </div>

            {/* PAGINACIÓN */}
            {totalPaginas > 1 && (
              <div className="au-pagination">
                <button className="au-pagbtn" onClick={() => setPagina(1)} disabled={pagina === 1}>«</button>
                <button className="au-pagbtn" onClick={() => setPagina(p => Math.max(1, p - 1))} disabled={pagina === 1}>Anterior</button>
                {Array.from({ length: totalPaginas }, (_, i) => i + 1)
                  .filter(p => p === 1 || p === totalPaginas || (p >= pagina - 1 && p <= pagina + 1))
                  .reduce((acc, p) => {
                    if (acc.length > 0 && p - acc[acc.length - 1] > 1) acc.push('...');
                    acc.push(p);
                    return acc;
                  }, [])
                  .map((p, i) => p === '...' ? (
                    <span key={`dots-${i}`} style={{ padding: '4px 6px', color: '#6b7280' }}>...</span>
                  ) : (
                    <button
                      key={p}
                      className={`au-pagbtn${pagina === p ? ' active' : ''}`}
                      onClick={() => setPagina(p)}
                      style={{ background: pagina === p ? '#dc2626' : '#fff', color: pagina === p ? '#fff' : '#1f2937' }}
                    >
                      {p}
                    </button>
                  ))
                }
                <button className="au-pagbtn" onClick={() => setPagina(p => Math.min(totalPaginas, p + 1))} disabled={pagina === totalPaginas}>Siguiente</button>
                <button className="au-pagbtn" onClick={() => setPagina(totalPaginas)} disabled={pagina === totalPaginas}>»</button>
              </div>
            )}
          </>
        )}
      </div>
    </div>
  );
}
